import { useContext } from 'react'

import { ReservationSuccessContext } from '@/context'

export const useReservationSuccess = () => useContext(ReservationSuccessContext)
